export enum Environment {
	Test = 'test',
	Preprod = 'preprod',
	Demo = 'demo',
	Prod = 'prod',
}
